enum VueModalPopModule  {
  DemoEvent = 0,
  FreezeEvent = 1,
}
export default Object.freeze(VueModalPopModule);

